


































































































import { Component, Vue, Prop } from "vue-property-decorator";


@Component({})
export default class InfoCustomer extends Vue {
  @Prop(Object) order!: object;

  public isComponentModalActive = false;
  
}
